/**
 * Created by razial on 27.05.2026.
 */

const EditorMap2dBackgroundControls = cc.Node.extend({
    ctor: function (editor) {
        this._super();

        this.editor = editor;

        const styles = cleverapps.styles.EditorMap2dBackgroundControls;

        const keyToLetter = {};
        for (const keyName in InputDispatcher.KEY) {
            keyToLetter[InputDispatcher.KEY[keyName]] = keyName;
        }

        this.editHint = new EditorHintView();
        this.editHint.refresh(EditorMap2dBackgroundControls.COMMANDS.map((command) => ({
            key: `${command.key !== undefined ? `${keyToLetter[command.key]} + ` : ""}⬅⬆`,
            description: command.description
        })));
        this.editHint.setAnchorPoint(0.5, 0.5);
        this.valuesHint = this.createValuesHint();

        this.layout = new cleverapps.Layout([this.editHint, this.valuesHint], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
        this.layout.setAnchorPoint(0.5, 0.5);
        this.addChild(this.layout);

        this.updateSize();

        editor.on("changeLayer", this.onChangeLayer.bind(this), this);
        editor.map.on("changeBackground", this.onChangeBackground.bind(this), this);
        this.onChangeLayer(editor.layer);
    },

    updateSize: function () {
        const styles = cleverapps.styles.EditorMap2dBackgroundControls;

        this.setContentSize(this.layout.width, this.layout.height);
        this.layout.setPosition(this.width / 2, this.height / 2);
        this.setAlignment(styles.position);
    },

    onChangeBackground: function () {
        this.valuesHint = this.createValuesHint();

        this.layout.setItems([this.editHint, this.valuesHint]);

        this.updateSize();
    },

    onChangeLayer: function (layer) {
        if (layer === Map2dEditor.LAYER_BACKGROUND) {
            this.startEditing();
        } else {
            this.stopEditing();
        }
    },

    createValuesHint: function () {
        const styles = cleverapps.styles.EditorMap2dBackgroundControls.valuesHint;
        const pos = this.editor.map.getBackgroundPosition();
        const scale = this.editor.map.getBackgroundScale();

        const text = cleverapps.UI.generateOnlyText(
            `dx: ${pos.x}   dy: ${pos.y}   scale: ${scale.x}`,
            cleverapps.styles.FONTS.EDITOR_HINT
        );

        const layout = new cleverapps.Layout([text], {
            direction: cleverapps.UI.VERTICAL,
            padding: styles.padding
        });
        layout.setAnchorPoint(0.5, 0.5);
        layout.setPosition(layout.width / 2, layout.height / 2);

        const background = new cc.Scale9Sprite(bundles.tool.frames.tool_bg);
        background.setContentSize(layout.width, layout.height);
        background.setAnchorPoint(0.5, 0.5);
        background.addChild(layout);

        return background;
    },

    startEditing: function () {
        this.setVisible(true);

        if (this.keyboardListener) {
            return;
        }

        this.keyboardListener = cleverapps.inputDispatcher.on("keypressed", (key) => {
            const arrowKeys = [InputDispatcher.KEY.up, InputDispatcher.KEY.down, InputDispatcher.KEY.left, InputDispatcher.KEY.right];
            if (!arrowKeys.includes(key) || this.editor.boundsMode) {
                return;
            }

            const command = EditorMap2dBackgroundControls.COMMANDS.find((cmd) => !cmd.key || cleverapps.inputDispatcher.isPressed(cmd.key));
            if (command) {
                command.action(this.editor, key);
            }
        }, this);
    },

    stopEditing: function () {
        this.setVisible(false);

        if (this.keyboardListener) {
            this.keyboardListener.clear();
            delete this.keyboardListener;
        }
    }
});

EditorMap2dBackgroundControls.MOVE_STEP = 1;
EditorMap2dBackgroundControls.MOVE_STEP_FAST = 20;
EditorMap2dBackgroundControls.SCALE_STEP = 0.05;

EditorMap2dBackgroundControls.COMMANDS = [{
    description: "Scale",
    key: InputDispatcher.KEY.s,
    action: function (editor, arrowKey) {
        const step = EditorMap2dBackgroundControls.SCALE_STEP;
        const scale = editor.map.getBackgroundScale();
        let delta = 0;

        switch (arrowKey) {
            case InputDispatcher.KEY.up:
            case InputDispatcher.KEY.right: delta = step; break;
            case InputDispatcher.KEY.down:
            case InputDispatcher.KEY.left: delta = -step; break;
        }

        editor.doCommand("setBackgroundScale", { x: +(scale.x + delta).toFixed(2), y: +(scale.y + delta).toFixed(2) });
    }
}, {
    description: "Move",
    key: undefined,
    action: function (editor, arrowKey) {
        const step = cleverapps.inputDispatcher.isPressed(InputDispatcher.KEY.shift)
            ? EditorMap2dBackgroundControls.MOVE_STEP_FAST : EditorMap2dBackgroundControls.MOVE_STEP;
        const pos = editor.map.getBackgroundPosition();
        let dx = 0, dy = 0;

        switch (arrowKey) {
            case InputDispatcher.KEY.left: dx = -step; break;
            case InputDispatcher.KEY.right: dx = step; break;
            case InputDispatcher.KEY.down: dy = -step; break;
            case InputDispatcher.KEY.up: dy = step; break;
        }

        editor.doCommand("setBackgroundPosition", { x: pos.x + dx, y: pos.y + dy });
    }
}];

cleverapps.styles.EditorMap2dBackgroundControls = {
    margin: 10,

    position: {
        x: { align: "center" },
        y: { align: "top", dy: -20 }
    },

    valuesHint: {
        padding: {
            x: 10,
            y: 10
        }
    }
};
